import React from 'react';
import ServiceCard from './ServiceCard';
import services from './data/services'; // Adjust path if `services.js` is in `data/` folder

const Services = () => {
    return (
        <div
            style={{
                display: 'flex',
                flexWrap: 'wrap',
                justifyContent: 'center',
                gap: '20px',
                padding: '20px',
            }}
        >
            {services.map((service) => (
                <ServiceCard key={service.id} service={service} />
            ))}
        </div>
    );
};

export default Services;
